import React, { useEffect } from "react";
import styled from "styled-components";
import Banner from "../components/homeComponents/Banner";
import Banner2 from "../components/homeComponents/Banner2";
import Stats from "../components/homeComponents/Stats";
import ScrollSection from "../components/homeComponents/WeDoSection";
import WeDoSection from "../components/homeComponents/WeDoSection";
import TransformationSection from "../components/homeComponents/TransformationSection";
import ScrollingTextSection from "../components/homeComponents/ScrollingTextSection";
import HappyClients from "../components/homeComponents/HappyClients";
import FocusDetailSection from "../components/homeComponents/FocusDetailSection";
import FAQSection from "../components/homeComponents/FAQSection";
import ContactSection from "../components/homeComponents/ContactSection";
import Contact from "./Contact";
import Reviews from "../components/homeComponents/Reviews";
import Map from "../components/homeComponents/Map";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Era Aesthetics";
  }, []);
  return (
    <Container>
      <Banner />
      <Stats />
      <WeDoSection />
      <TransformationSection />
      <ScrollingTextSection />
      <HappyClients />
      <FocusDetailSection />
      <Reviews />
      <Contact />
      {/* <Map /> */}
      {/* <Banner2 /> */}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  overflow-x: hidden;
`;

export default Home;
